export const BASE_PATHS = {
  googleAuthenticator: "/google-authenticator",
  scripts: "/scripts",
  adminPanel: "/admin-panel",
  manuals: "/manuals",
  aiModels: "/ai-models",
  mappingAlias: "/mapping-alias",
  uiRemote: "/ui-remote",
  dashboard: "/dashboard",
  notExistingPage: "/404",
  login: "/login",
  drsPipe: "/ovs-bot-pipeline",
  apiKeys: "/api-keys",
  apiDocs: "/api/docs/",
};

export const API_PAGE_PATHS = {
  createNewKey: "create-api-key",
};
